import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import LoginLogo from "../../assets/img/logo-large.png";
import userService from '../../Services/UserService';
import { Button } from '@headlessui/react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useAuth from '../../hooks/useAuth';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import UserService from '../../Services/UserService';
import { useSearchParams } from "react-router-dom";

interface FormResetPassword {
    password: string;
    confirmPassword: string;
  }
  export default function ResetPassword()  {
    const [errorMessage, setErrorMessage] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const [accessCode, setAccessCode] = useState<string | null>(null);
    const [accessEmail, setAccessEmail] = useState<string | null>(null);

    const navigate = useNavigate();

    const schema = yup.object().shape({
        password: yup.string().required('Password is required'),
        confirmPassword: yup
        .string()
        .oneOf([yup.ref('password'),""], 'Passwords must match')
        .required('Please confirm your password'),
      });
    
      const {
        register,
        handleSubmit,
        formState: { errors },
        watch,
      } = useForm<FormResetPassword>({
        resolver: yupResolver(schema),
        mode: 'onSubmit',
      });
    
      const watchFields = watch();
    
      useEffect(() => {
        setErrorMessage('');
      }, [watchFields]);

      useEffect(() => {
        let code = searchParams.get("AccessCode");
        let email = searchParams.get("email");
        setAccessCode(code);
        setAccessEmail(email);
      }, [searchParams]);
    
      async function onSubmit() {
        try {
          const password = watchFields.password;
          const confirmPassword = watchFields.confirmPassword;
          let code = searchParams.get("AccessCode");
        let email = searchParams.get("email");
          if (!code || !email) {
            toast.error('Invalid access code or email', {
                position: 'top-right',
            });
            return;
          }
        const confirmAccessCode = await UserService.VerifyResetPassword(code, email)
        if(confirmAccessCode){
          const postData = {
            email: accessEmail,
            password:password
          }
          // setEmailAddress(email);
          console.log(password);
          const result = await UserService.ResetPassword(postData);
          console.log(result)
          if (result?.status === 200){
              toast.success('Your password reset successfully', {
                  position: 'top-right',
                });
                setTimeout(() => {
                  navigate(process.env.REACT_APP_PublicPath + "/login", { replace: false });
                }, 2000); 
          }else {
              toast.error('Failed to reset password, Please try again', {
                  position: 'top-right',
                });
            }

        }else{
          toast.error('Email verification is failed, Please try again!', {
            position: 'top-right',})
        }
        
        
        } catch (error) {
            toast.error("Something went wrong, Please try again", {
                position: 'top-right',
              });
        }
      }
    return(
      <div className="w-full text-center">
      <div className="min-h-screen-82 flex items-center justify-center bg-brand-mist">
        <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
          <h2 className="text-2xl font-semibold mb-5 text-left">Reset your password</h2>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 text-left">
                Password
              </label>
              <input
                type="password"
                id="password"
                {...register('password')}
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                placeholder="New password"
              />
              {errors.password && <p className="text-red-500 text-left">{errors.password.message}</p>}
            </div>
            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 text-left">
                Confirm Password
              </label>
              <input
                type="password"
                id="confirmPassword"
                {...register('confirmPassword')}
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                placeholder="Re-enter your new password"
              />
              {errors.confirmPassword && <p className="text-red-500 text-left">{errors.confirmPassword.message}</p>}
            </div>
    
            <button
              type="submit"
              className="w-full py-3 px-4 bg-green text-lg font-bold text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              Reset
            </button>
          </form>
        </div>
      </div>
    </div>
      
    )
}
